export default "__VITE_ASSET__wiBqMvtD__"